<template>
  <div class="container">
    <div ref="tabContainer" class="tabs">
      <div
        class="tab"
        v-for="tab in tabs"
        :key="tab.name"
        :class="{ active: modelValue === tab.name }"
        @click="onTabClick(tab.name)"
        ref="tabList"
      >
        {{ tab.text }}
      </div>
    </div>
    <div ref="showBtn" class="more" @click="show = !show">
      {{ showText }}
      {{ tabLength }}
      <img :src="arrowBlueIcon" class="icon" :class="{ rotated: show }" />
    </div>
    <transition name="popup">
      <div ref="popup" v-show="show" class="all_content">
        <div class="tab" v-for="tab in tabs" :key="tab.name" @click="onTabClick(tab.name)">
          {{ tab.text }}
        </div>
      </div>
    </transition>
  </div>
</template>
<script lang="ts" setup>
import arrowBlueIcon from '@/assets/icons/arrow-down-blue.svg';
interface ITab {
  name: string;
  text: string;
}
const props = defineProps<{
  modelValue: string;
  tabs?: ITab[];
}>();

const show = ref(false);
const popup = ref<HTMLDivElement>();
const showBtn = ref<HTMLDivElement>();
const emit = defineEmits(['change', 'update:modelValue']);
const showText = computed(() => (show.value ? '收起' : '展开'));
const tabLength = computed(() => {
  if (!props.tabs?.length) {
    return;
  }
  return `(${props.tabs.length})`;
});

const tabContainer = ref<HTMLDivElement>();
const tabList = ref<HTMLDivElement[]>();

function onTabClick(to: string) {
  emit('change', to);
  emit('update:modelValue', to);
  show.value = false;
  nextTick(() => {
    const target = tabList.value?.find(item => item.className.includes('active'));
    if (!target) {
      return;
    }
    const { offsetLeft } = target;
    tabContainer.value!.scrollTo({
      left: offsetLeft,
      behavior: 'smooth',
    });
  });
}

const fn = (e: MouseEvent) => {
  if (e.target !== showBtn.value && e.target !== popup.value) {
    show.value = false;
  }
};
onMounted(() => {
  addEventListener('click', fn);
});
onUnmounted(() => {
  removeEventListener('click', fn);
});
</script>
<style lang="less" scoped>
@media screen and (min-width: 800px) {
  .container {
    position: relative;
    margin-top: 60px;
    .tabs {
      width: 1160px;
      height: 60px;
      display: flex;
      overflow: hidden;
      position: relative;
      .tab {
        padding: 16px 32px;
        font-size: 20px;
        line-height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        cursor: pointer;
        flex-shrink: 0;

        @media screen and (min-width: 800px) {
          &.active {
            background: rgba(22, 93, 255, 0.1);
            color: #386aff;
            font-weight: 500;
            &:after {
              content: ' ';
              display: block;
              position: absolute;
              height: 3px;
              left: 0;
              bottom: 0;
              width: 100%;
              background: #165dff;
            }
          }
          &:hover {
            color: #386aff;
            font-weight: 500;
          }
        }
        // @media screen and (max-width: 800px) {
        //   &.active {
        //     color: #386aff;
        //     font-weight: 500;
        //     background: rgba(22, 93, 255, 0.1);
        //     &:after {
        //       content: ' ';
        //       display: block;
        //       position: absolute;
        //       height: 3px;
        //       left: 0;
        //       bottom: 0;
        //       width: 100%;
        //       background: #165dff;
        //     }
        //   }
        // }
      }
    }
    .more {
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 120px;
      letter-spacing: 0.02em;
      color: #165dff;
      font-size: 20px;
      user-select: none;
      cursor: pointer;
      background: linear-gradient(270deg, #ffffff 73.81%, rgba(255, 255, 255, 0) 111.9%);
      .icon {
        pointer-events: none;
        margin-left: 4px;
        transition: transform 0.2s ease-in-out;
        will-change: transform;
      }
      .rotated {
        transform: rotateZ(180deg);
      }
    }
    .tab {
      padding: 16px 60px;
      font-size: 20px;
      line-height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      cursor: pointer;

      @media screen and (min-width: 800px) {
        &.active {
          background: rgba(22, 93, 255, 0.1);
          color: #386aff;
          font-weight: 500;
          &:after {
            content: ' ';
            display: block;
            position: absolute;
            height: 3px;
            left: 0;
            bottom: 0;
            width: 100%;
            background: #165dff;
          }
        }
        &:hover {
          color: #386aff;
          font-weight: 500;
        }
      }
      // @media screen and (max-width: 800px) {
      //   &.active {
      //     color: #386aff;
      //     font-weight: 500;
      //     background: rgba(22, 93, 255, 0.1);
      //     &:after {
      //       content: ' ';
      //       display: block;
      //       position: absolute;
      //       height: 3px;
      //       left: 0;
      //       bottom: 0;
      //       width: 100%;
      //       background: #165dff;
      //     }
      //   }
      // }
    }
    @keyframes popup {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
    .popup-enter-active {
      animation: popup 0.2s ease-in both;
    }
    .popup-leave-active {
      animation: popup 0.2s ease-in alternate-reverse;
    }
    .all_content {
      background: #ffffff;
      box-shadow: 0px 2px 24px rgba(114, 148, 226, 0.14);
      border-radius: 4px;
      position: absolute;
      z-index: 2;
      top: 68px;
      left: 0;
      right: 0;
      display: flex;
      flex-wrap: wrap;
    }
  }
}
</style>
<style lang="less" scoped>
@media screen and (max-width: 800px) {
  .container {
    z-index: 2;
  }
  .more {
    display: none;
  }
  .all_content {
    display: none;
  }
  .tabs {
    margin-top: 24px;
    box-sizing: border-box;
    height: 40px;
    display: flex;
    padding: 0 16px;
    gap: 16px;
    overflow-x: scroll;
  

    .tab {
      // padding: 0 16px;
      white-space: nowrap;
      // padding: 0 12px;
      font-size: 14px;
      font-weight: 500;
      line-height: 28px;
      display: flex;
     
      align-items: center;
      justify-content: center;
      position: relative;
      cursor: pointer;

      &.active {
        color: #386aff;
        font-weight: 400;
        // background: rgba(22, 93, 255, 0.1);

        &:after {
          content: ' ';
          display: block;
          position: absolute;
          height: 3px;
          left: 0;
          bottom: 0;
          width: 100%;
          background: #165dff;
        }
      }
    }
    &::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>
